(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminPasswordEditSettingsController', AdminPasswordEditSettingsController);

    function AdminPasswordEditSettingsController(
        $controller,
        $state,
        $scope,
        $translate,
        messenger,
        moment,
        lodash,
        apiClient,
        settingsCollection,
        siteAssociateTypesCollection,
        assetScoreTypesCollection,
        recurrenceRulesService,
        elogsUserCollection,
        contractManager,
        elbSettings,
        module,
        modulesService,
        meridianConfigurationCollectionResponse,
        confirmationModal,
        fileTypeService
    ) {
        const vm = this;
        const base = $controller('AdminEditSettingsController', {
            $state: $state,
            $scope: $scope,
            $translate: $translate,
            messenger: messenger,
            moment: moment,
            lodash: lodash,
            apiClient: apiClient,
            settingsCollection: settingsCollection,
            settingsFields: [
                'password_days_till_change_notification',
                'password_disallow_previous_passwords',
                'password_force_change',
                'password_min_characters',
                'password_require_number',
                'password_require_punctuation',
                'password_require_uppercase'
            ],
            siteAssociateTypesCollection: siteAssociateTypesCollection,
            assetScoreTypesCollection: assetScoreTypesCollection,
            recurrenceRulesService: recurrenceRulesService,
            elogsUserCollection: elogsUserCollection,
            contractManager: contractManager,
            elbSettings: elbSettings,
            module: module,
            modulesService: modulesService,
            meridianConfigurationCollectionResponse: meridianConfigurationCollectionResponse,
            confirmationModal: confirmationModal,
            fileTypeService: fileTypeService,
            validateTabSettings: null,
            buildTabSettingFormTypes: () => ({
                'password_days_till_change_notification': { type: 'number', options: { invalid: false} },
                'password_disallow_previous_passwords': { type: 'checkbox', notRequired: true },
                'password_force_change': { type: 'checkbox', notRequired: true },
                'password_min_characters': { type: 'number', options: { invalid: false} },
                'password_require_number': { type: 'checkbox', notRequired: true },
                'password_require_punctuation': { type: 'checkbox', notRequired: true },
                'password_require_uppercase': { type: 'checkbox', notRequired: true }
            })
        });

        angular.extend(vm, base);
    }
})();
